// export interface Device {
//   value: any;
//   text: string;
//   deviceInfo: MediaDeviceInfo;
// }

// export enum DeviceType {
//   AUDIO_IN,
//   AUDIO_OUT,
//   VIDEO
// }

// export interface AvailableDevices {
//     audioInput: Device[];
//     audioOutput: Device[];
//     video: Device[]
// }
export interface MediaDevice {
  deviceId: string;
  groupId: string;
  kind: MediaDeviceKind;
  label: string;
}


export interface AvailableDevices {
    audioInputs: MediaDevice[];
    audioOutputs: MediaDevice[];
    videoInputs: MediaDevice[]
}

export const initialiAvailableDevices: AvailableDevices = {
  audioInputs: [],
  audioOutputs: [],
  videoInputs: []
}